<p-card>
  <app-card-title key="project.steps.rfq.invitationPreview" />
  @if (!isStepPrerequisiteCompleted()) {
    <app-previous-step-incomplete-notice />
  } @else {
    @if (contractParametersResource.isLoading()) {
      <app-loading />
    } @else {
      <p-tabs
        appTabsUnsavedReveal
        [value]="activeTabIndex()"
        (valueChange)="onTabChange($event!)"
        scrollable
      >
        <p-tablist>
          <p-tab [value]="0" [appTabStatus]="mailPreviewTabStatus.signal()">
            {{ 'project.steps.rfq.invitationPreview.tab.mailPreview' | transloco }}
          </p-tab>
          <p-tab [value]="1" [appTabStatus]="readOnlyTabStatus">
            {{ 'project.steps.rfq.invitationPreview.tab.proposalParameters' | transloco }}
          </p-tab>
          <p-tab [value]="2" [appTabStatus]="readOnlyTabStatus">
            {{ 'project.steps.rfq.invitationPreview.tab.systemIntegration' | transloco }}
          </p-tab>
          <p-tab [value]="3" [appTabStatus]="readOnlyTabStatus">
            {{ 'project.steps.rfq.invitationPreview.tab.previewPriceList' | transloco }}
          </p-tab>
          <p-tab [value]="4" [appTabStatus]="proposalDocumentGuidanceTabStatus.signal()">
            {{ 'project.steps.rfq.invitationPreview.tab.proposalDocumentsGuidance' | transloco }}
          </p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-card>
            <p-tabpanel [value]="0">
              <app-step-8-2-1-rfq-mail-preview
                [preloadedData]="invitationPreviewResponse()"
                [stepLocked]="isButtonDisabled()"
                (statusChange)="onMailPreviewStatusChange($event)"
              ></app-step-8-2-1-rfq-mail-preview>
            </p-tabpanel>

            <p-tabpanel [value]="1">
              <app-card-title key="project.steps.proposalParameters" />
              <app-proposal-parameter-panels
                [projectId]="projectId!"
                [contractParametersContainer]="contractParametersResource.value()!"
                [isReadOnly]="true"
              />
            </p-tabpanel>
            <p-tabpanel [value]="2">
              @if (loadedTabs().has(2)) {
                <app-card-title [key]="'project.steps.rfq.invitationPreview.systemIntegration'" />
                <app-step-8-2-2-rfq-system-integration
                  [projectId]="projectId"
                ></app-step-8-2-2-rfq-system-integration>
              }
            </p-tabpanel>
            <p-tabpanel [value]="3">
              <app-card-title key="project.steps.rfq.invitationPreview.previewPriceList" />
              <app-step-8-2-3-rfq-preview-price-list
                [invitationOfferOverview]="invitationOfferOverview()"
                [stepLocked]="isButtonDisabled()"
                [isReadOnly]="true"
                [isDraft]="true"
              ></app-step-8-2-3-rfq-preview-price-list>
            </p-tabpanel>
            <p-tabpanel [value]="4">
              <app-card-title key="project.steps.rfq.invitationPreview.participationGuidance" />
              @if (loadedTabs().has(4)) {
                <app-step-8-2-4-rfq-proposal-document-guidance
                  [stepLocked]="isButtonDisabled()"
                  (statusChange)="onProposalDocumentGuidanceStatusChange($event)"
                >
                </app-step-8-2-4-rfq-proposal-document-guidance>
              }
            </p-tabpanel>
          </p-card>
        </p-tabpanels>
      </p-tabs>
    }
  }
</p-card>
